import { useEffect } from 'react';
import { readUrlString } from '@/utils/url-state/url-state';
import { useCompanyStore } from '@/store/app.store';

/**
 * The range is deliberately not synced here. `resolveStoredTimeRange` reads the same url
 * synchronously at store creation and rejects unknown presets; repeating the read on mount
 * would write the value it just refused straight back into the store and localStorage.
 */
export function useUrlCompanyToStoreSync(initialUrl: URLSearchParams) {
  const { companyName, setCompanyName } = useCompanyStore();

  useEffect(() => {
    const urlCompany = readUrlString(initialUrl, 'company_name');
    if (urlCompany && urlCompany !== companyName) {
      setCompanyName(urlCompany);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
